import {GameValidator} from '@colonist/game-mechanic-validators'
import {useGameStore} from '../GameStoreContext.ts'
import {useMemo} from 'react'

export const useGameValidator = () => {
    const gameState = useGameStore((state) => state.gameState)
    const userStates = useGameStore((state) => state.gameUserStates.userStates)

    return useMemo(() => {
        const gameValidator = new GameValidator(gameState, userStates)

        return gameValidator
    }, [gameState, userStates])
}
